// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.subtotal-label[data-v-3375593f]{\n  color: #72737A;\n  font-weight: 700;\n  font-size: 14px;\n}\n.subtotal-value[data-v-3375593f] {\n  color: #2B2B2B;\n  font-size: 18px;\n  font-weight: 700;\n}\n.add-item-button[data-v-3375593f] {\n  color: #72737A;\n  font-weight: 700;\n  cursor: pointer;\n  font-size: 12px;\n}\n.icon-pointer[data-v-3375593f] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
